module.exports = __webpack_public_path__ + "img/violet_033.0c2c4635.png";